import React, { useEffect, useState } from 'react' 
import Card from './Card'
import styles from './category.module.css' 
import { Link, useNavigate } from 'react-router-dom'
import Navbar from '../NavbarFooter/Navbar'
import Footer from '../NavbarFooter/Footer'
import axios from 'axios';
// import categoryBG from '../../assets/categoryBG.jpg'
// import custImage from '../../assets/shirtBack.jpg' 


function Category(props) {
  const [photos, setPhotos] = useState([]);

  useEffect(() => {
    axios.get("https://sportsblendserver.netlify.app/.netlify/functions/api/displayCategory")
      .then((res) => {
        // console.log("\nTHe photos or data are ", res.data, "\n");
        setPhotos(res.data);

      })
      .catch((err) => console.log(err));
  }, [])
  const [colorChange, setColorchange] = useState("");
  const changeNavbarColor = () => {
    if (window.scrollY >= 10) {
      setColorchange(" rgb(70, 70, 70)");
    }
    else {
      setColorchange("");
    }
  };
  window.addEventListener('scroll', changeNavbarColor);
 
  // const navigate = useNavigate();

  return (
    <div className='mpBG'>
      <Navbar bgcolor={colorChange} />
      {/* <div className="background-container" style={{ background: `url(${categoryBG})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>

        <div className={styles.homeRoot}>

          <h1 className={styles.xHero} style={{ fontSize: '3.5rem' }}>Customize your own Shirt!</h1>
          <div className={styles.xcardMainDiv}>
            <div className={styles.xcardSuperDiv}>
              <div onClick={()=>navigate('/productPage/65380ddac794fcf8d4778bd5')} className={styles.xcard} style={{ backgroundImage: `url(${custImage})`}}>
                <div className={styles.xplayerName}>
                  <h1>Your Name</h1>
                </div>
                <div className={styles.xplayerNum}>
                  <h1 style={{ userSelect: 'none' }}>10</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}

      
            <div className="background-container">

                <div className='home-root'>
                    <h1 class="xh1"><h1>Sports<span>Blend</span></h1><div class="xroller">
                        <span id="xrolltext">Choose<br />
                            a<br />
                            category<br />
                            <span id="xspare-time">Own it!</span><br />
                            </span>
                    </div>
                    </h1>
                </div>
            </div>

      <div className={styles.secDiv}>
        <h4 className={styles.sportTitle}>Categories</h4>
        <h1 className={styles.Hero}>Choose a Category</h1>

        <div className={styles.cardsContainer}>
          {photos.map(({ name, photo, _id }) => (
            <div key={_id}>
              <Link to={`/productPage/${_id}`} className='card-link'>
                <Card name={name} cardImage={`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo}`} /*overlayImage={shirtBack}*/ /></Link>
            </div>
          ))}
        </div>
      </div>
      <Footer />

    </div>
  )
}
{/* <div className='footer'>
        <div className='footercontent'>
          <h3>JerseyFusion</h3>
          <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi magni, dolor id eaque aliquid vel.</p>

        </div>
        <div className='footercontent'>
          <br />
          <br />
          <h1>Copyright @Faisal Murad</h1>
          <p>Lorem ipsum dolor sit amet consectetur, adipisicing elit. Sequi magni, dolor id eaque aliquid vel.</p>

        </div>
      </div> */}

export default Category